export default __webpack_public_path__ + "static/media/er.61c776fc.webp";